import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { FeatureFlagService } from './feature-flag.service';
/* eslint-disable @angular-eslint/directive-selector */
@Directive({
  selector: '[featureFlag]',
  providers: [FeatureFlagService],
  standalone: false,
})
export class FeatureFlagDirective {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private featureFlagService: FeatureFlagService
  ) {}

  @Input() set featureFlag(flag: string) {
    if (this.featureFlagService.isActive(flag)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
